import React from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { setCookieConsent } from "@/lib/cookieConsent";

// באנר הסכמת עוגיות (תיקון 13 לחוק הגנת הפרטיות). מוצג עד שהמשתמש בוחר;
// הבחירה נשמרת דרך lib/cookieConsent ומשודרת כאירוע window, ולכן אין צורך
// ב-callback — GlobalOverlays (App.jsx) מאזין לאירוע ומסיר את הבאנר.
// האתר משתמש כיום רק בעוגיות/אחסון חיוניים (התחברות והעדפות); כפתור
// "אישור הכל" קיים כדי שהוספת אנליטיקס עתידית תעבוד עם הסכמה קיימת.
export default function CookieConsent() {
  return (
    <div
      role="region"
      aria-label="הודעה על שימוש בעוגיות"
      dir="rtl"
      className="fixed inset-x-0 z-[60] p-3 sm:p-4 print:hidden"
      style={{ bottom: "var(--bottom-stack, 0px)" }}
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-card text-card-foreground shadow-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0" aria-hidden="true">
            <Cookie className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-heading font-bold text-foreground text-sm mb-1">
              שימוש בעוגיות באתר
            </p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              אנו משתמשים בעוגיות ובאחסון מקומי החיוניים לפעולת האתר — התחברות מאובטחת
              ושמירת ההעדפות שלכם בלבד. איננו משתמשים בעוגיות פרסום או מעקב של צדדים
              שלישיים. פרטים מלאים ב
              <Link to="/privacy#cookies" className="text-primary font-medium hover:underline">
                מדיניות הפרטיות
              </Link>
              .
            </p>
            {/* הבאנר הזה הוא הסכמת עוגיות (תיקון 13). התנאים מוצגים כאן כהפניה
                בלבד — הסכמה לתנאי שימוש נוצרת מעצם השימוש, לא מלחיצה על "אישור
                עוגיות", ולכן אין לערבב את שני הדברים לכדי אישור אחד. */}
            <p className="text-xs text-muted-foreground leading-relaxed mt-2">
              השימוש באתר כפוף ל
              <Link to="/terms/" className="text-primary font-medium hover:underline">תנאי השימוש</Link>
              , הכוללים הגבלת אחריות ואת אחריות המשתמש לנתונים שהוא מזין. האתר מונגש לפי
              תקן ת"י 5568 — <Link to="/accessibility/" className="text-primary font-medium hover:underline">הצהרת נגישות</Link>.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <button
                onClick={() => setCookieConsent("all")}
                className="px-4 py-2 rounded-xl gradient-primary text-white text-sm font-bold shadow-md hover:opacity-90 transition"
              >
                אישור הכל
              </button>
              <button
                onClick={() => setCookieConsent("essential")}
                className="px-4 py-2 rounded-xl border border-border bg-background text-foreground text-sm font-medium hover:bg-muted transition"
              >
                עוגיות חיוניות בלבד
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
